module.exports = __webpack_public_path__ + "img/Cyclo-logo-bike.6357bd81.png";